module.exports = __webpack_public_path__ + "media/images/black_history_month/personal-gardens-95318a620bfede429d26032e5fdda251.png";